import * as Yup from 'yup'

import { emailIsAvailable } from '@mindfulchefuk/services/emailIsAvailable'
import validateEmail from '@mindfulchefuk/components/Checkout/FormUserDetails/validateEmail'

export const serverEmailExistsSchema = Yup.string().test(
  'email-exists',
  'email-exists',
  emailIsAvailable
)

export const serverEmailRealSchema = Yup.string().test(
  'email-real',
  `Sorry, it seems this email address doesn't exist`,
  (email: string) => validateEmail(email, false)
)
